import React from 'react';
import PropTypes from 'prop-types';
import { FDClickableText, FDStack, FDTitleText } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

const ExternalSystemLinkSection = ({ label, value }) => {
  return (
    <FDStack direction={'column'} spacing={2}>
      <FDTitleText value={'Salesforce Link'} />
      <FDClickableText
        appearance={'standalone'}
        label={label}
        href={value}
        {...dataAttrs('external-system-link')}
      />
    </FDStack>
  );
};

ExternalSystemLinkSection.defaultProps = {
  label: undefined,
  value: undefined,
};

ExternalSystemLinkSection.propTypes = {
  label: PropTypes.string,
  value: undefined,
};

export default ExternalSystemLinkSection;
